// extracted by mini-css-extract-plugin
export default {"jefe_departamento_page_container":"SecretariaAdmunCuPage_jefe_departamento_page_container__6NrfW"};